/**
 * Vantaggi carrello (snippets/cart-perks.liquid): ridisegna la barra
 * spedizione gratuita dopo ogni modifica AJAX del carrello.
 * La soglia e' in euro: per i mercati in altra valuta si converte con
 * Shopify.currency.rate, lo stesso tasso che Shopify usa per i prezzi.
 */
(function () {
  'use strict';

  function thresholdCents(el) {
    var eur = parseFloat(el.getAttribute('data-threshold-eur')) || 100;
    var rate = (window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate)) || 1;
    return Math.round(eur * rate * 100);
  }

  function format(cents, currency) {
    var value = cents / 100;
    var lang = (document.documentElement.lang || 'it').substring(0, 2);
    try {
      return new Intl.NumberFormat(lang, {
        style: 'currency',
        currency: currency || 'EUR',
        minimumFractionDigits: value % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      }).format(value);
    } catch (e) {
      return value.toFixed(2) + ' ' + (currency || 'EUR');
    }
  }

  function paint(el, cart) {
    if (!cart || cart.item_count === 0) {
      el.style.display = 'none';
      return;
    }
    el.style.display = '';

    var ship = el.querySelector('[data-cp-ship]');
    var msg = el.querySelector('[data-cp-msg]');
    var bar = el.querySelector('[data-cp-bar]');
    if (!ship || !msg) return;

    var limit = thresholdCents(el);
    var remaining = limit - cart.total_price;
    var done = remaining <= 0;

    msg.textContent = done
      ? el.getAttribute('data-t-done')
      : el.getAttribute('data-t-under').replace('__AMT__', format(remaining, cart.currency));

    if (bar) {
      bar.style.width = Math.min(100, Math.max(0, cart.total_price / limit * 100)).toFixed(1) + '%';
      bar.classList.toggle('is-done', done);
    }
    ship.style.visibility = '';
  }

  var pending = false;
  function refresh() {
    if (pending) return;
    if (!document.querySelector('[data-cart-perks]')) return;
    pending = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-perks]').forEach(function (el) { paint(el, cart); });
      })
      .catch(function () {})
      .then(function () { pending = false; });
  }

  var CART_MUTATION = /\/cart\/(add|change|update|clear)/;

  var _fetch = window.fetch;
  window.fetch = function () {
    var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
    var result = _fetch.apply(this, arguments);
    if (CART_MUTATION.test(url)) {
      result.then(function () { setTimeout(refresh, 250); }).catch(function () {});
    }
    return result;
  };

  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._cpUrl = url;
    return _open.apply(this, arguments);
  };
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this._cpUrl && CART_MUTATION.test(this._cpUrl)) {
      this.addEventListener('load', function () { setTimeout(refresh, 250); });
    }
    return _send.apply(this, arguments);
  };

  document.addEventListener('theme:cart:loaded', refresh);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
